import { ControlsButton } from '../../../../../_components/ControlsButton'
import React from 'react'
import { S_ConfirmModal } from '../../../../LenderViews/FundingRequestPage/ConfirmModal'
import { Button } from '../../../../../_components/Button'
import { useModal } from '../../../../../_reduxHooks/modal.hook'
import { deleteInvoice } from '../../../../../_services/lender.service'

const confirmRemoveInvoice = (invoiceToDelete, openModal, closeModal, onRemove) => {
  const ConfirmDeleteModal = () => {
    return (
      <S_ConfirmModal>
        <h2>Confirm Remove Invoice</h2>
        <p>Are you sure you want to remove invoice #{invoiceToDelete?.invoice_number}? This action cannot be undone.</p>
        <div className="actions-row">
          <Button onClick={closeModal} text="Cancel" />
          <Button
            className="destroy"
            onClick={async () => {
              await deleteInvoice(invoiceToDelete.id).then(() => {
                onRemove(invoiceToDelete.id)
                closeModal()
              })
            }}
            text="Confirm"
          />
        </div>
      </S_ConfirmModal>
    )
  }

  openModal(ConfirmDeleteModal, {})
}

export const RemoveScheduleInvoice = ({ entity, onRemove, isDisabled }) => {
  const { openModal, closeModal } = useModal()

  return (
    <ControlsButton
      icon="close"
      isDisabled={isDisabled}
      onClick={() => {
        confirmRemoveInvoice(entity, openModal, closeModal, onRemove)
      }}
    />
  )
}
